// @flow
import * as React from 'react';
import {
  Form, RadioGroup, Radio, TextArea, Checkbox,
} from 'informed';
import moment from 'moment';

import {
  Label, PrimaryText, HeaderText, Success, Error,
} from '../../Typography.jsx';
import { Button, PrimaryButton } from '../../Buttons.jsx';
import DateText from '../../DateText.jsx';

import styles from '../../../styles/patientPages/testing/TB.scss';

type Props = {
  editRow: ?Object,
  // if view only, no fields editable
  viewOnly: bool,
  /*
    (rowId: string, row: Object) => {}
  */
  handleSaveRow: Function,
  /*
    (row: Object) => {}
  */
  handleSaveNewRow: Function,
  closeModal: Function,
}

class TBScreeningForm extends React.Component<Props, {}> {
  formApi: {
    getState: Function,
    setValue: Function,
    reset: Function,
  }

  componentDidUpdate() {
    this.formApi.reset();
    if (this.props.editRow && !this.props.viewOnly) {
      this.formApi.setValue('date', moment(this.props.editRow.date).format());
    } else if (!this.props.viewOnly) {
      this.formApi.setValue('date', moment().format());
    }
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  handleSave = () => {
    const state = this.formApi.getState();
    if (state.invalid) {
      return;
    }
    if (!this.props.editRow) {
      this.props.handleSaveNewRow(state);
    } else if (Object.keys(state.touched).length) {
      this.props.handleSaveRow(this.props.editRow._id, state);
    }
    this.props.closeModal();
  }

  /* eslint-disable max-len */
  render() {
    const { viewOnly } = this.props;
    const editRow = this.props.editRow || {};
    const { editors, editDates } = editRow;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    return (
      <Form getApi={this.setFormApi} autoComplete='off'>
        <HeaderText>Tuberculosis Screening</HeaderText>
        <PrimaryText>Questions</PrimaryText>
        <ol>
          <li>
            {viewOnly
              ? (editRow.question1 ? <Success>✓ </Success> : <Error>✗ </Error>)
              : <Checkbox field='question1' initialValue={editRow.question1} />
            }
              Current cough?
          </li>
          <li>
            {viewOnly
              ? (editRow.question2 ? <Success>✓ </Success> : <Error>✗ </Error>)
              : <Checkbox field='question2' initialValue={editRow.question2} />
            }
              Fever for 2 weeks or more?
          </li>
          <li>
            {viewOnly
              ? (editRow.question3 ? <Success>✓ </Success> : <Error>✗ </Error>)
              : <Checkbox field='question3' initialValue={editRow.question3} />
            }
            <div className={styles.question3}>
              {'For adults: Night sweats for 2 weeks or more?\n'}
              {'For children (< 15 y.o.): Poor weight gain or failure to thrive?'}
            </div>
          </li>
          <li>
            {viewOnly
              ? (editRow.question4 ? <Success>✓ </Success> : <Error>✗ </Error>)
              : <Checkbox field='question4' initialValue={editRow.question4} />
            }
              History of contact with a TB case?
          </li>
        </ol>
        <ol type='a'>
          <li>If Yes to Q1, <Label>probe for duration of cough.</Label> If duration is more than 2 weeks, consider that as a presumptive TB case.</li>
          <li>If Yes to Q1, but duration is less than 2 weeks, it <Label>must be accompanied by Yes in any of the other questions (i.e. Q2-Q4).</Label></li>
          <li>If no to Q1, <Label>consider as presumptive if at least two (2) of the other symptoms (e.g. Fever & Night Sweats, etc.) exists.</Label></li>
          <li><Label>For children (less than 15 years old), History of Contact with TB case alone should be considered presumptive TB case.</Label></li>
        </ol>
        <div className={styles.screenResults}>
          <PrimaryText>Screen Results</PrimaryText><br />
          {viewOnly
            ? editRow.positive || '--'
            : <RadioGroup field='positive' initialValue={editRow.positive}>
              <span className={styles.radioButton}>
                <Radio value={'Positive'} />Positive (presumptive TB)
              </span>
              <span className={styles.radioButton}>
                <Radio value={'Negative'} />Negative
              </span>
              <span className={styles.radioButton}>
                <Radio value={'Unknown'} />Unknown
              </span>
            </RadioGroup>
          }
        </div>
        <div className={styles.notes}>
          <PrimaryText>Notes</PrimaryText><br />
          {viewOnly
            ? editRow.notes || '--'
            : <TextArea field='notes' initialValue={editRow.notes} />
          }
        </div>
        <table>
          <tbody>
            <tr>
              <td><PrimaryText>Exam Date </PrimaryText></td>
              <td>
                {viewOnly
                  ? (editRow.date ? moment(editRow.date).format() : '--')
                  : <DateText field='date' item={editRow} />
                }
              </td>
            </tr>
            <tr className={styles.editHistoryRow}>
              <td><strong>Edit History </strong></td>
              <td>{editHistory || '--'}</td>
            </tr>
          </tbody>
        </table>
        {!viewOnly && <PrimaryButton onClick={this.handleSave}>Save</PrimaryButton>}
        <Button onClick={this.props.closeModal}>{viewOnly ? 'Close' : 'Cancel'}</Button>
      </Form>
    );
  }
}

export default TBScreeningForm;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/TBScreeningForm.jsx